<template>
    <span :aria-describedby="accessibilityId" class="symbol">
      <template v-if="props.type === 'help'">
        <svg
          aria-hidden="true" aria-label="question-icon" class="svg-icon question-icon" height="512"
          viewBox="0 0 512 512"
          width="512" xmlns="http://www.w3.org/2000/svg"><title id="" lang="sv"> svg</title><g
          class="svg__color" fill="var(--spsm-gray-1)" fill-rule="evenodd"><path
          d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"></path></g></svg>
      </template>
      <template v-if="props.type === 'warning'">
        <svg :class="{'red-svg': props.redColor}" viewBox="0 0 576 512"><path
          d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z" /></svg>
      </template>
      <template v-if="props.type === 'warning-agreement'">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.1083 14.9999L11.4416 3.33319C11.2962 3.0767 11.0854 2.86335 10.8307 2.71492C10.576 2.56649 10.2864 2.48828 9.99161 2.48828C9.69678 2.48828 9.40724 2.56649 9.1525 2.71492C8.89777 2.86335 8.68697 3.0767 8.54161 3.33319L1.87494 14.9999C1.72801 15.2543 1.65096 15.5431 1.65162 15.837C1.65227 16.1308 1.73059 16.4192 1.87865 16.673C2.0267 16.9269 2.23923 17.137 2.49469 17.2822C2.75014 17.4274 3.03945 17.5025 3.33327 17.4999H16.6666C16.959 17.4996 17.2462 17.4223 17.4993 17.2759C17.7525 17.1295 17.9626 16.9191 18.1087 16.6658C18.2548 16.4125 18.3316 16.1252 18.3316 15.8328C18.3315 15.5404 18.2545 15.2531 18.1083 14.9999Z" stroke="#F0B100" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 7.5V10.8333" stroke="#F0B100" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 14.1665H10.0083" stroke="#F0B100" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </template>
      <template v-if="props.type === 'check'">
        <span class="fas fa-check check"></span>
      </template>
      <span v-if="props.symbolMessage" :id="accessibilityId" class="" role="tooltip">
        {{ props.symbolMessage }}
      </span>
    </span>
</template>


<script lang="ts">

import { defineComponent, reactive } from "vue";

export default defineComponent({
  name: "Symbol",
  components: {},
  props: {
    type: String,
    symbolMessage: String,
    accessibilityId: String,
    redColor: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const state = reactive({});

    let accessibilityId = props.accessibilityId?.toLowerCase().trim().replace(" ", "_").replace("å", "a").replace("ä", "a").replace("ö", "o") + "_information";

    return {
      state,
      props,
      accessibilityId
    };
  }
});

</script>

<style lang="scss">

.symbol {
  position: relative;

  [role="tooltip"] {
    position: absolute;
    opacity: 0;
    visibility: hidden;
    width: 0;
    height: 0;
    transition: opacity 0.4s ease;
    overflow: hidden;
  }

  &:hover {
    cursor: pointer;

    [role="tooltip"] {
      bottom: 100%;
      right: -1.4rem;
      bottom: calc(100% + 0.8rem);
      width: 200px;
      height: auto;
      padding: 0.8rem;
      opacity: 1;
      visibility: visible;
      z-index: 1000;
      background: #fff;
      color: #000;
      font-size: 1rem;
      font-weight: normal;
      text-align: left;
      border-radius: 0.4rem;
      border: 2px solid var(--spsm-gray-2);

      @media (min-width: 1600px) {
        bottom: auto;
        right: auto;
        left: -1.4rem;
        top: calc(100% + 0.8rem);
      }
    }
  }

  svg {
    display: inline-block;
    vertical-align: baseline;
    pointer-events: none;
    width: 1rem;
    height: auto;
  }

  .red-svg {
    filter: invert(12%) sepia(74%) saturate(7435%) hue-rotate(3deg) brightness(111%) contrast(120%);
  }

  .check {
    color: #008511;
    font-size: smaller;
  }
}

</style>
